module.exports = __webpack_public_path__ + "static/img/aepic-21.bbd136d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-21.jpg
// module id = Pg5j
// module chunks = 51